import React from "react";

const Logo = ({ variant = "navy", className = "" }) => {
  const isLight = variant === "light";
  const primary = isLight ? "#FFFFFF" : "#001E47";
  const accent = "#2BB0F1";
  const muted = isLight ? "rgba(255,255,255,0.55)" : "#64748B";

  return (
    <div
      className={`flex items-baseline gap-2 ${className}`}
      data-testid="brand-logo"
    >
      <div className="flex flex-col leading-none">
        <div className="flex items-baseline gap-[6px]">
          <span
            className="font-display tracking-[-0.01em] text-[18px] sm:text-[19px] font-semibold"
            style={{ color: primary }}
          >
            PORT&rsquo;S
          </span>
          <span
            className="font-display italic text-[18px] sm:text-[19px] font-medium"
            style={{ color: accent, lineHeight: 1 }}
          >
            &amp;
          </span>
          <span
            className="font-display tracking-[-0.01em] text-[18px] sm:text-[19px] font-semibold"
            style={{ color: primary }}
          >
            COLLECTORS
          </span>
        </div>
        <div className="flex items-center gap-2 mt-[6px]">
          <span
            className="block h-px w-4"
            style={{ background: accent }}
          />
          <span
            className="text-[9px] sm:text-[10px] uppercase tracking-[0.32em] font-medium"
            style={{ color: muted }}
          >
            portsdebt.es
          </span>
        </div>
      </div>
    </div>
  );
};

export default Logo;
